import {FormField} from './FormField';


export class TimeFormly extends FormField {

  constructor() {
    super();
    super.icon="fa fa-clock-o";
    super.name = 'temps_' + super.generateRandomId();
    super.type = 'time';
    super.title="temps"
    super.typename = 'Time';
  }
}
